import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
  }

  selectClear(e){
    e.preventDefault();
    const birthdaySelect = document.querySelector("#search_birthday");
    if (birthdaySelect.value != null){
      birthdaySelect.value = null;
    }
  }
}
